/**
* Form Module
* Pack of all list components and services
**/

//Core
import { NgModule, ModuleWithProviders }       from '@angular/core';
import { CommonModule }       from '@angular/common';

import { GenericModule } from './generic.module';
import { UIModule } from '../ui/ui.module';

//Components
import { TextInput } from '../ui_forms/textInput/textInput.component';
import { CardModule } from '../ui_card/card.module';
// import { DropdownComponent } from 'libraries/ui_dropdown/dropdown.component'

//services
// import { FocusDirective } from 'libraries/directive/focus/focus.directive';
// import { AutofocusDirective } from 'libraries/directive/autofocus/autofocus.directive';

@NgModule({
    imports: [
      CommonModule,
      GenericModule,
      UIModule,
      CardModule,
    ],
    declarations: [
      TextInput,
    //   FocusDirective,
    //   AutofocusDirective
      // DropdownComponent
    ],
    exports: [
      TextInput,
    //   FocusDirective,
    //   AutofocusDirective
      // DropdownComponent
    ],
    bootstrap: [
    ],
    providers: [
    ]
})
export class FormModule { }
